import { DateTime } from "luxon";

export function url(strings: TemplateStringsArray, ...variables: (string | number | boolean | URLSearchParams)[]): string {
    let u = '';

    for (let i = 0; i < variables.length; i++) {
        const val = variables[i];
        u += strings[i] + (val instanceof URLSearchParams ? val.toString() : encodeURIComponent(val));
    }

    u += strings[strings.length - 1];

    return u;
}

type QueryParamValue = string | number | boolean | DateTime | null | undefined;

type QueryParams<T> = {
    [K in keyof T]: QueryParamValue | QueryParamValue[];
};

/**
 * Generates a `URLSearchParams` instance from an object
 *
 */
export function buildQueryParams<T>(params: QueryParams<T>): URLSearchParams {
    const queryParams = new URLSearchParams();

    for (let [key, val] of Object.entries(params)) {
        if (val === null || val === undefined) {
            continue;
        } else if (Array.isArray(val)) {
            for (const v of val) {
                if (v === null || v === undefined)
                    continue;
                if (v instanceof DateTime)
                    queryParams.append(key, v.toISODate());
                else
                    queryParams.append(key, v.toString());
            }
        } else if (val instanceof DateTime) {
            queryParams.append(key, val.toISODate());
        } else {
            queryParams.append(key, val.toString());
        }
    }

    return queryParams;
}
